/*------------------------------------*\
    measurements
\*------------------------------------*/
module.exports = function(){



    /*------------------------------------*\
        scope variable
    \*------------------------------------*/
    var measpopupSwiper;


    /*------------------------------------*\
        leading zero padding
    \*------------------------------------*/
    function pad(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    }




    /*------------------------------------*\
        util
    \*------------------------------------*/
    var inputMaskFeetInchToInch = function(val){

        var feets = parseInt( String(val).slice(0,1) );
        var inches = parseInt( String(val).slice(1,3) );

        var calc = feets * 12;

        if (String(inches) !== 'NaN'){
            calc += inches;
        }

        return calc;

    };






    /*------------------------------------*\
        util
    \*------------------------------------*/
    var inchToFeetInch = function(val, showFull){

        var inches = parseFloat(val).toFixed(0);
        var feet = Math.floor(inches / 12);
        inches %= 12;

        if (showFull) {

            // _′_[_]″

            return String(feet) + '′' + String(inches) + '″';
        }

        return parseInt( String(feet) + String(inches) );

    };







    /*------------------------------------*\
        validate height
    \*------------------------------------*/
    var validHeight = function(rawString){

        var feet = parseInt( rawString.slice(0,1) );
        var inch = parseInt( rawString.slice(2,4) );

        //alertify.log('feet: '+feet);
        //alertify.log('inch: '+inch);

        if (inch > 11) {
            return false;
        }

        return true;

    };





    /*------------------------------------*\
        formats trigger
    \*------------------------------------*/
    var formatTriggers = function(){

        // WEIGHT
        $('[data-trigger-meas-type-id="1"] .js-meas-dynamic-value').each(function(index, el) {
            var value = parseInt( $(this).closest('.js-measpopup-trigger').attr('data-value') );
            $(this).text( value + ' lbs');
        });

        // HEIGHT
        $('[data-trigger-meas-type-id="2"] .js-meas-dynamic-value').each(function(index, el) {
            var value = parseInt( $(this).closest('.js-measpopup-trigger').attr('data-value') );
            $(this).text( inchToFeetInch(value, true ) );
        });

        // EVERYTHING ELSE
        $('[data-trigger-meas-type-id] .js-meas-dynamic-value').each(function(index, el) {
            var isNotWeight = String( $(this).closest('[data-trigger-meas-type-id]').attr('data-trigger-meas-type-id') ) !== '1';
            var isNotHeight = String( $(this).closest('[data-trigger-meas-type-id]').attr('data-trigger-meas-type-id') ) !== '2';

            if (isNotWeight && isNotHeight) {
                var value = parseFloat( $(this).closest('.js-measpopup-trigger').attr('data-value') ).toFixed(2);
                $(this).text( value + '″');
            }
        });

    };

    formatTriggers();











    /*------------------------------------*\
        add pagination label
        just adds text to swiper pages
    \*------------------------------------*/
    var addPaginationLabel = function(){
        $('.js-measpopup-swiper').find('.measpopup__slide').each(function(index, el) {
            var label = '<div>' + $(el).attr('data-pagination-label') + '</div>';
            $('.js-measpopup-swiper').find('.swiper-pagination-bullet').eq(index).html(label);
        });
    };





    /*------------------------------------*\
        youtube iframe shanenigans
    \*------------------------------------*/
    var enableIframeSrc = function(){
        $('.js-measpopup-slide').find('[js-meas-iframe-container]').find('iframe').remove();
        // curent
        var iframeContainer = $('.js-measpopup-slide.swiper-slide-active').find('[js-meas-iframe-container]');
        var iframeSrc = iframeContainer.attr('js-meas-iframe-container');
        var iframe = $('<iframe>', {
            src: iframeSrc,
            'frameborder': "0",
            'class': 'js-meas-iframe',
        }).attr('width', 550).attr('height', 300);
        iframeContainer.append(iframe);
    };







    /*------------------------------------*\
        initializes swiper
    \*------------------------------------*/
    var initSwiper = function(){
        measpopupSwiper = new Swiper ('.js-measpopup-swiper', {
            loop: false,
            // Optional parameters
            paginationClickable: true,
            //spaceBetween: 30,
            //grabCursor: true,
            simulateTouch: false,
            // If we need pagination
            pagination: '.js-measpopup-swiper .swiper-pagination',
            // Navigation arrows
            //nextButton: '.js-measpopup-swiper .swiper-button-next',
            //prevButton: '.js-measpopup-swiper .swiper-button-prev',
            // And if we need scrollbar
            //scrollbar: '.js-measpopup-swiper .swiper-scrollbar',
            onSlideChangeEnd: function(swiper) {
                setTimeout(function(){
                    enableIframeSrc();
                }, 50);
            }
        });
        window.measpopupSwiper = measpopupSwiper;
    };








    /*------------------------------------*\
        loops through all inputs
        in slider and sets inputmask
    \*------------------------------------*/
    var setInputMask = function(){

        // http://jsfiddle.net/msj5qfu1/187/
        // https://github.com/RobinHerbots/Inputmask
        // alias: 'numeric',
        // suffix: '″',
        // numericInput: true,
        // integerDigits: 2,
        // integerOptional: false,
        // rightAlign: true,
        // clearIncomplete: true,
        // digits: 2,

        // WEIGHT
        $('[data-meas-type-id="1"] .js-type-value').attr('placeholder', '___ lbs');
        $('[data-meas-type-id="1"] .js-type-value').inputmask({
            mask: '999 lb\\s',
            placeholder: '___ lbs',
            showMaskOnHover: false,
            clearIncomplete: false,
        });

        // HEIGHT
        $('[data-meas-type-id="2"] .js-type-value').attr('placeholder', '_′__″');
        $('[data-meas-type-id="2"] .js-type-value').inputmask({
            mask: '9′99″',
            placeholder: '_′__″',
            showMaskOnHover: false,
            clearIncomplete: false,
        });

        // EVERYTHING ELSE (deprecated)
        /*
        $('[data-meas-type-id] .js-type-value').each(function(index, el) {
            var isNotWeight = String( $(el).closest('[data-meas-type-id]').attr('data-meas-type-id') ) !== '1';
            var isNotHeight = String( $(el).closest('[data-meas-type-id]').attr('data-meas-type-id') ) !== '2';
            if (isNotWeight && isNotHeight) {
                $(el).attr('placeholder', '_″');
                $(el).inputmask({
                    greedy: false,
                    mask: '99.99″',
                    clearIncomplete: false,
                });
            }
        });
        */

    };




    /*------------------------------------*\
        set data to slide
    \*------------------------------------*/
    var setDataToSlide = function(thisEl){

        thisEl.closest('.js-measurement-profile').find('.js-measpopup-trigger[data-trigger-meas-type-id]').each(function(index, el) {

            var typeId = $(el).attr('data-trigger-meas-type-id');
            var measVal = $(el).attr('data-value');
            var measValId = $(el).attr('data-value-id');



            // WEIGHT
            if (parseInt(typeId)==1) {
                measVal = pad( parseInt(measVal) , 3);
            }

            // HEIGHT
            else if (parseInt(typeId)==2) {
                measVal = inchToFeetInch(measVal);
            }

            // EVERYTHING ELSE
            else {
                measVal = pad( parseFloat(measVal).toFixed(2) , 5);
            }



            $('.js-measpopup-slide[data-meas-type-id="' + typeId + '"]').attr('data-meas-value-id', measValId);
            $('.js-measpopup-slide[data-meas-type-id="' + typeId + '"]').find('.js-val-id').text(measValId);
            $('.js-measpopup-slide[data-meas-type-id="' + typeId + '"]').find('.js-type-value').val(measVal);

        });

    };




    /*------------------------------------*\
        change single trigger value
    \*------------------------------------*/
    var changeTriggerValue = function(measValueId, value, parent){
        $('.js-measpopup-trigger[data-value-id="' + measValueId + '"]').find('.js-meas-dynamic-value').text(value);
        $('.js-measpopup-trigger[data-value-id="' + measValueId + '"]').attr('data-value', value);
        formatTriggers();
    };





    /*------------------------------------*\
        slide to id
    \*------------------------------------*/
    var slideToId = function(id, thisEl){
        var slideIndex;
        $(measpopupSwiper.slides).each(function(index, el) {
            if ($(el).attr('data-meas-type-id') == id) {
                slideIndex = index;
            }
        });
        // haxfix
        measpopupSwiper.slideTo(slideIndex-1);
        measpopupSwiper.slideTo(slideIndex+2);
        //
        measpopupSwiper.slideTo(slideIndex);
        //alertify.log('slideto: ' + slideIndex);
    };













    /*------------------------------------*\
        click on trigger
    \*------------------------------------*/
    $(document).on('click', '.js-measpopup-trigger', function(event) {
        event.preventDefault();
        var thisEl = $(this);
        $.magnificPopup.open({
            items: {
                src: $('#measpopup'),
            },
            mainClass: 'mfp-zoom-in  mfp-measpopup',
            type: 'inline',
            removalDelay: 350,
            preloader: false,
            showCloseBtn: true,
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    var measTypeId = thisEl.attr('data-trigger-meas-type-id');
                    setTimeout(function(){
                        initSwiper();
                        enableIframeSrc();
                        addPaginationLabel();
                        setDataToSlide(thisEl);
                        slideToId(measTypeId, thisEl);
                        setInputMask();
                    }, 50);
                },
            }
        });
    });








    /*------------------------------------*\
        single value submit
    \*------------------------------------*/
    $(document).on('submit', '.js-measpopup-single-edit-form', function(event) {
        event.preventDefault();
        var slide = $(this).closest('.js-measpopup-slide');
        var measTypeId = parseInt( slide.attr('data-meas-type-id') );
        var measValueId = parseInt( slide.attr('data-meas-value-id') );
        var thisForm = $(this).closest('form');
        var valueInput = $(this).closest('form').find('.js-type-value');



        // WEIGHT
        if(measTypeId == 1) {
            var value = valueInput.inputmask('unmaskedvalue');
        }

        // HEIGHT
        else if(measTypeId == 2) {
            if ( !validHeight( valueInput.val() ) ) {
                alertify.alert('Please provide inches value between 0 and 11.');
                return false;
            }
            var value = inputMaskFeetInchToInch( valueInput.inputmask('unmaskedvalue') );
        }

        // EVERYTHING ELSE
        else {
            var value = valueInput.val();
        }


        if (!value) {
            alertify.alert('Please provide value.');
            return false;
        }



        //console.log(measTypeId, measValueId, value);

        window.eph.patchCustomerMeasurement(measTypeId, measValueId, value, function(){
            changeTriggerValue(measValueId, value,  slide);
            $.magnificPopup.instance.close();
        });



        //alertify.alert(value);

    });









    /*------------------------------------*\
        debug logs on input
    \*------------------------------------*/
    /*

    // WEIGHT
    $(document).on('input', '[data-meas-type-id="1"] .js-type-value', function(event) {
        alertify.log('Weight Pounds: ' + $(this).inputmask('unmaskedvalue') );
    });

    // HEIGHT
    $(document).on('input', '[data-meas-type-id="2"] .js-type-value', function(event) {
        alertify.log('Height Inches: ' + inputMaskFeetInchToInch( $(this).inputmask('unmaskedvalue') ) );
    });

    // EVERYTHING ELSE
    $(document).on('input', '[data-meas-type-id] .js-type-value', function(event) {
        var isNotWeight = String( $(this).closest('[data-meas-type-id]').attr('data-meas-type-id') ) !== '1';
        var isNotHeight = String( $(this).closest('[data-meas-type-id]').attr('data-meas-type-id') ) !== '2';

        if (isNotWeight && isNotHeight) {
            alertify.log('Everything Else Inches: ' + parseFloat( String( $(this).val() ).slice(0, -1) ) );
        }
    });

    */




    /*------------------------------------*\
        round to 25
    \*------------------------------------*/

    var originalValue;

    $(document).on('focus', '.js-round-to-25', function(event) {
        originalValue = $(this).val();
    });



    $(document).on('blur', '.js-round-to-25', function(event) {

        /*
        var number = parseInt( $(this).inputmask('unmaskedvalue') );
        var new_number = number;

        if (number > 99 && number < 999) {
            new_number = number * 10;
        }

        if(new_number > 999) {
            new_number = parseInt( Math.round(new_number/25) * 25 );
            // alertify.log(number + ' -> ' + new_number );
        }


        $(this).val(new_number);
        console.log(parseInt(number));
        console.log(parseInt(new_number));
        */


        var number = $(this).val();

        if (!number) {
            $(this).val(originalValue);
            alertify.alert('You need to provide some value.');
            return false;
        }

        var number = parseFloat(number);

        if ( (number % 0.25) > 0 ) {
            var roundedNumber = parseFloat( Math.round(number/0.25) * 0.25 ).toFixed(2);
            $(this).val(roundedNumber);
            alertify.alert('It\'s required for this value to be rounded to nearest 1/4. <br> We\'ve changed this value for you.');
            return false;
        }

        if ($('.swiper-pagination-bullet-active div').text() === 'Wrist') {

            if ( number > 11 ) {
                $(this).val(originalValue);
                alertify.alert('The provided value is too high.');
                return false;
            }


            if ( number < 3 ) {
                $(this).val(originalValue);
                alertify.alert('The provided value is too low.');
                return false;
            }

        } else {

            if ( number > 99 ) {
                $(this).val(originalValue);
                alertify.alert('The provided value is too high.');
                return false;
            }


            if ( number < 10 ) {
                $(this).val(originalValue);
                alertify.alert('The provided value is too low.');
                return false;
            }

        }




        $(this).val(parseFloat(number).toFixed(2));




    });

}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/measurements_edit.js